import { useEffect, useRef, useState } from 'react';
import { PositionList, getPositions } from '../../helpers/apiService';
import styles from './style.module.scss';
import { Filter, FilterMenu } from '../filterMenu/filterMenu';
import { List } from '../list/list';

export function PositionSearchWrapper({ positionSearchURL, language }) {
	const search = positionSearchURL.split('/?data=')[1];
	const basePath = positionSearchURL.split('/?data=')[0];
	const urlAsObject = search && JSON.parse(decodeURI(search).replaceAll('%3A', ':').replaceAll('%2C', ','));
	
	const containerRef = useRef(null);
	const [searchResults, setSearchResults] = useState<PositionList | null>(null);
	const [searchResultsFiltered, setSearchResultsFiltered] = useState<PositionList | null>(null);
	const [itemCount, setItemCount] = useState(10);
	const [filters, setFilters] = useState<Filter>({});

	const setFilter = (filterName: string, filterValue?: string) => {
		const tempFilters = { ...filters };
		if (filterName !== 'PositionSchedule') {
			if (filterValue) {
				tempFilters[filterName] = [filterValue];
			} else {
				delete tempFilters[filterName];
			}
		} else {
			if (filterValue) {
				const alreadyActiveFilters = tempFilters[filterName] || [];
				const positionIfAlreadyExists = alreadyActiveFilters?.find((schedule) => schedule === filterValue);

				if (positionIfAlreadyExists && alreadyActiveFilters.length === 1) {
					tempFilters[filterName] && delete tempFilters[filterName];
				}
				if (positionIfAlreadyExists && alreadyActiveFilters.length > 1) {
					const removed = alreadyActiveFilters?.filter((activeFilter) => activeFilter !== filterValue);
					tempFilters[filterName] = removed;
				}
				if (!positionIfAlreadyExists && alreadyActiveFilters.length > 0) {
					tempFilters[filterName] = [filterValue, ...alreadyActiveFilters];
				}
				if (!positionIfAlreadyExists && alreadyActiveFilters.length === 0) {
					tempFilters[filterName] = [filterValue];
				}
			}
		}
		setFilters(tempFilters);
	};

	useEffect(() => {
		if (!searchResultsFiltered) {
			getPositions(basePath, language, urlAsObject)
				.then((response) => {
					setSearchResults(response);
					setSearchResultsFiltered(response);
				})
				.catch((error) => {
					console.error(error);
				});
		} else {
			let searchResultsItemsFiltered = searchResults?.SearchResult.SearchResultItems;
			Object.entries(filters).forEach((filterKey) => {
				const filterName = filterKey[0];
				const filterValues = filterKey[1];

				searchResultsItemsFiltered =
					searchResultsItemsFiltered &&
					searchResultsItemsFiltered.filter((item) => {
						let matchFilter = false;
						filterValues.forEach((test) => {
							if (
								item.MatchedObjectDescriptor[filterName][0] &&
								(item.MatchedObjectDescriptor[filterName][0].Name
									? item.MatchedObjectDescriptor[filterName][0].Name.includes(test)
									: item.MatchedObjectDescriptor[filterName][0].CityName.includes(test))
							) {
								matchFilter = true;
							}
						});
						return matchFilter;
					});
			});

			setSearchResultsFiltered({
				LanguageCode: searchResults?.LanguageCode || 'EN',
				SearchResult: {
					SearchResultCount: itemCount,
					SearchResultCountAll: searchResultsItemsFiltered?.length || 0,
					SearchResultItems: searchResultsItemsFiltered || [],
				},
			});
		}
	}, [filters]);

	return (
		<div className={`${styles.container} container container--spacing clr__bg--sand`}>
			<div className={styles.innerContainer} ref={containerRef}>
				<List
					searchResultsFiltered={searchResultsFiltered}
					itemCount={itemCount}
					setItemCount={setItemCount}
					resetFilters={() => setFilters({})}
				/>
				<FilterMenu
					setDropdown={setFilter}
					filters={filters}
					entries={searchResultsFiltered}
					allEntries={searchResults}
					scrollRef={containerRef}
				/>
			</div>
		</div>
	);
}
